import React, { Component } from 'react';
import { FormGroup, Input, Button, ListGroupItem, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import { data } from '../../constants/Constants';
import color from '../../constants/Colors';
import { BuscarPedidoMasivo } from '../../store/sagas/pedidoApi';
import { notificacion, getStatePage } from '../../utilitarios/util';
import localStorageCustom from '../../utilitarios/localStorage';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import Spinner from "../reusable/Loader";

export class GenerarPedidoMasivo extends Component {
  static displayName = GenerarPedidoMasivo.name;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isEditable: true,
      file: {},
      fileBase64: null,
      dealer: {},
      linea: {},
      asociado: {},
      alertas: [],
      pedidoMasivo: [],
      page: 1,
      size: data.PageSize,
      currentPage: 1,
      error: false,
      errorMessage: '',
    };
  }

  checkParams() {
    const { state } = this.props.location;
    if (state) {
      // let datosBuscador = params.datosBuscador;
      // this.setState({ textBuscador: datosBuscador.text, textBuscadorOri: datosBuscador.text })
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  load = async () => {
    let data = localStorageCustom.prototype.getUsuario()
    this.setState({ file: {}, loading: false, dealer: data.dealer, linea: data.linea, asociado: data.asociado })
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      this.load();
      this.checkParams();
    } else
      window.location.href = "/";
  }

  render() {
    const { loading, isEditable, error, errorMessage, file, alertas, pedidoMasivo } = this.state;
    const navigation = this.props.navigation;
    const colorEditable = isEditable ? color.verdeClaro : color.celeste;

    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="desktop">
          <div className="title_banner">
            <Container><h1><SvgAssets icon="icon-add-file" fill='#fff' />Pedido masivo</h1></Container>
            <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
          </div>
          <div className="breadcrumb">
            <Container>
              <ul>
                <li><Link to='/dashboard'>Dashboard</Link></li>
                <li>Pedidos</li>
                <li>Generar Pedido masivo</li>
              </ul>
            </Container>
          </div>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile"><SvgAssets icon="icon-add-file" fill="#fff" />Pedido masivo</h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill={'#1B52B2'} />
            <p className="paragraph-1 text-center msg_card_desktop light">
              El archivo a subir debe ser de extensión <strong className="bold">txt.</strong> Adicional a ello debe contener<br className="desktop" /> las columnas <strong className="bold">código del repuesto y cantidad</strong>
            </p>
            <div className="cargar_pedido_masivo">
              <h6 className="paragraph-1 verde mt-3 bold">Seleccione archivo:</h6>
              <FormGroup className="icon">
                <div className="custom-file">
                  <input type="file" className="custom-file-input" id="file-1" aria-describedby="file-1"
                    onChange={this.pickDocument}
                  />
                  <label className="custom-file-label form-control" htmlFor="file-1">{file.name ? file.name : 'Carga masiva'}</label>
                </div>
                <a onClick={() => { document.getElementById("file-1").click() }}>
                  <SvgAssets icon="icon-clip" className='input-icon' fill={color.verdeClaro} />
                </a>
                {error == true ? <FormFeedback>{errorMessage}</FormFeedback> : null}
              </FormGroup>
              <div className="text-center mobile">
                <button
                  className='btn-block bg_verde mt-3'
                  disabled={file.name ? false : true}
                  onClick={() => this.postBuscarProductos()}>
                  cargar archivo<SvgAssets icon="icon-add-file" className='ml-2' fill={color.verdeClaro} />
                </button>
              </div>
            </div>
          </div>
          <div className="text-center mt-5 desktop">
            <button
              className='btn-block bg_verde'
              disabled={file.name ? false : true}
              onClick={() => this.postBuscarProductos()}>
              cargar archivo<SvgAssets icon="icon-add-file" fill='#fff' className='ml-2' />
            </button>
          </div>
        </Container>
      </div>
    );
  }

  postBuscarProductos = async () => {
    this.setState({ loading: true })
    this.postBuscador();
    // const response = await FileSystem.readAsStringAsync(this.state.file.uri, {
    //   encoding: FileSystem.EncodingType.Base64,
    // })
    //   .then((data) => {
    //     this.postBuscador(data);
    //   })
    //   .catch(
    //     error => {
    //       this.setState({ loading: false })
    //       console.error("error=====>", error)
    //     })
  }
  pickDocument = (e) => {
    let input = e.currentTarget;
    try {
      let res = null;
      if (input.files && input.files[0]) {
        res = input.files[0];
        if (res.type.toLowerCase() != "text/plain") {
          this.setState({ error: true, errorMessage: 'Debe seleccionar archivo con extensión .txt' });
          return;
        }
        var reader = new FileReader();

        reader.onload = (e) => {
          this.setState({ file: res, fileBase64: e.target.result.split(',')[1], error: false, errorMessage: '' });
          // console.log(e.target.result);
          // $('#blah').attr('src', e.target.result);
        }

        reader.readAsDataURL(input.files[0]); // convert to base64 string
      }
      else
        this.setState({ file: {}, fileBase64: null });


      // let res = await DocumentPicker.getDocumentAsync({
      //   base64: true,
      //   // copyToCacheDirectory: false,
      //   type: 'text/plain'
      // });
      // this.setState({ file: res })
    } catch (err) {
      // Expo didn't build with iCloud, expo turtle fallback
      // this.webview.injectJavaScript('selectFile()');
    }
  }

  postBuscador = async () => {
    this.setState({
      loading: true
    })
    BuscarPedidoMasivo(this.state.dealer, this.state.linea, this.state.asociado, this.state.page, this.state.fileBase64, true)
      .then(result => {
        if (result.mo.type == "success") {

          this.setState({
            loading: false,
            pedidoMasivo: result.dto.repuestos,
            alertas: result.dto.alertas
          }, async () => {
            let datosBuscador = {
              pedidoMasivo: result.dto.repuestos,
              alertas: result.dto.alertas
            }
            this.props.history.push({
              pathname: '/pedido-masivo',
              state: { datosBuscador }
            });
          })

        } else {
          throw new Error(`<ul class="text-justify" style="padding-left: 0">${result.mo.listMessage.map(x => `<li style="list-style: none">${x}</li>`).join("")}</ul>`);
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });
  }
}
